import { useState } from "react";
import { href } from "../lib/route";

/* A PENDING ROW'S OWN JOIN LINK, COPIED (W72 step 1) — `Copy link` on the board and the roster.
 * The link is `href({ name: "join" })`'s absolute path form, the one a universal link can match and
 * the one the invite sheet already hands out. An expired token says so instead of copying a dead
 * link. ⚠️ A refused clipboard (outside a secure context) is SAID, never swallowed. */
export function CopyLink({ link, name }: { link: { token: string; expired: boolean } | null; name: string }) {
  const [said, setSaid] = useState<"idle" | "copied" | "refused">("idle");
  if (link === null) return null;
  if (link.expired) return <span className="ours-caption">Link expired</span>;
  const url = href({ name: "join", token: link.token });
  return (
    <button
      type="button"
      className="ours-action ours-copy"
      aria-label={`Copy ${name}'s invitation link`}
      onClick={() => {
        navigator.clipboard.writeText(url).then(() => setSaid("copied"), () => setSaid("refused"));
      }}
    >
      {said === "copied" ? "Copied" : said === "refused" ? "Copy refused — select it on the client page" : "Copy link"}
    </button>
  );
}
